<div class="validation-body">
  @if (!this.offerError) {
    <div>
      <div class="validation-wrapper">
        <mat-card class="validation-card not-available-text">
          <p>Please enter the 6 digit code sent to your email.</p>
          <code-input #codeInput
            [isCodeHidden]="false"
            [codeLength]="6"
            (codeChanged)="onCodeChanged($event)"
            (codeCompleted)="onCodeCompleted($event)">
          </code-input>
          <br>
          @if (this.invalidCode) {
            <p class="error-text">*The code you entered was invalid.</p>
          }
          <button 
            class="button-request resend-button" 
            #cardButton
            [hidden]="!this.resendButtonEnabled">
            RESEND CODE
          </button>
        </mat-card>
      </div>
    </div>
  }
</div>
